import { apiDomain } from "env";

const cartaNegativa = payload =>
  `${apiDomain("portal/beneficiario")}/cartas_negativa_guia/baixar?` +
  `${
    payload?.codigoBeneficiario
      ? `codigoBeneficiario=${payload?.codigoBeneficiario}&`
      : ""
  }` +
  `${payload?.numeroGuia ? `numeroGuia=${payload?.numeroGuia}` : ""}`;

const cartaNegativaStatus = payload =>
  `${apiDomain("portal/beneficiario")}/cartas_negativa_guia/status?` +
  `${
    payload?.codigoBeneficiario
      ? `codigoBeneficiario=${payload?.codigoBeneficiario}&`
      : ""
  }` +
  `${payload?.numeroGuia ? `numeroGuia=${payload?.numeroGuia}` : ""}`;

const guiasGrid = payload =>
  `${apiDomain("portal/beneficiario")}/guias/?` +
  `${
    payload?.codigoBeneficiario
      ? `codigoBeneficiario=${payload?.codigoBeneficiario}&`
      : ""
  }` +
  `${payload?.numeroGuia ? `numeroGuia=${payload?.numeroGuia}&` : ""}` +
  `${`pagina=${payload?.pagina}&`}` +
  `${payload?.size ? `size=${payload?.size}` : ""}`;

export default {
  cartaNegativa,
  cartaNegativaStatus,
  guiasGrid
};
